    export const api = process.env.VUE_APP_API;